export default {"src":"/login-app/[GIT_HASH]/_next/static/media/content_copy.a394e548.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};